<template>
    <y-accordion-item
        id="m-cart__coupons"
        :title="$t('cart.coupons.title')"
        class="m-cart__coupons mt-7"
    >
        <y-input
            v-model="coupons"
            type="text"
            name="coupons"
            no-label
            :disabled="$wait.is('loading-coupons') || disabled"
            :readonly="disabled"
        />

        <y-button
            :disabled="!coupons || disabled"
            loading-on="loading-coupons"
            color="primary"
            no-padding
            flat
            @click.prevent="verifyCoupon"
        >
            {{ $t('cart.coupons.button') }}
        </y-button>
    </y-accordion-item>
</template>

<script>
    import { YInput, YAccordionItem } from '@components';

    export default {
        name: 'Coupons',
        
        components: {
            YInput,
            YAccordionItem,
        },

        props: {
            /**
             * Order list id
             */
            orderListId: {
                type: [Number, String],
            },

            /**
             * Selected address id
             */
            selectedAddress: {
                type: [Number, String],
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                coupons : '',
                disabled: false,
            };
        },

        watch: {
            coupons: {
                /**
                 * Remove coupons when delete
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue) && !newValue) {
                        this.$emit('coupons');
                    }
                },
            },
        },

        methods: {
            /**
             * Verify coupons
             * 
             * @returns {Promise}
             */
            verifyCoupon() {
                if (!this.selectedAddress) {
                    return this.$toast.error(this.$t('cart.coupons.address_error'));
                }
                
                this.$wait.start('loading-coupons');
                return this.$services.Cart.myOrderCouponInquiry({
                    id     : this.orderListId,
                    coupons: [this.coupons.trim()],
                    address: this.selectedAddress,
                }).then((response) => {
                    const validCode = response.data.results.coupons[this.coupons.trim()] > 0;
                    if (validCode) {
                        this.disabled = true;
                        this.$toast.success(this.$t('cart.coupons.success'));
                        this.$emit('coupons', { coupon_id: this.coupons.trim(), total_discount: response.data.results.total_discount });
                    } else {
                        this.disabled = false;
                        this.$emit('coupons');
                        this.$toast.error(this.$t('cart.coupons.error'));
                    }
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('loading-coupons');
                });
            },
        },
    };
</script>
